// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"00631221","513":"6eaae53c"}[chunkId] + ".chunk.js";
};